import {U, __} from './global';

export const SHOWCASE = {
    addBlocked: false,
    row: false,
    keys: [],
    selected_showcase: false,
    codeReader: false,
    selectedDeviceId: '',
    slider: false,

    add_qr_sku: function(text) {
        $.ajax({
            type: "POST",
            url: "/aj",
            data: {
                action: 'slr',
                to: 'lookupbyqrsku',
                text: text
            },
            dataType: "json",
            timeout: 15000, // in milliseconds
            success: (data) => {

                let exists = [];

                if ($(".showcase-slide-content.filled").length > 0)
                    $(".showcase-slide-content.filled").map((i, item) => {
                        item=$(item);
                        exists.push(item.data('sku'));
                        return;
                    });

                if (exists.indexOf(data.product.sku) == -1) {
                    let slide = $(".showcase-slide.slick-center ");
                    slide.find(".showcase-slide-content").addClass('filled').data('sku', data.product.sku).html(data.product.sku + '<br /><img src="' + data.product.image + '" />');
                    this.slider.slick('slickNext');

                    if ((this.row.find('.showcase-col').length - 1) == slide.data('key')) {
                        if (this.row.next().length > 0) {
                            // append btn
                            $(".showcasecamera-layout__helpbuttons").html('<a href="#" class="showcasecamera-layout__gonextrow">До наступного ряду</a>');

                            /*
                            if (confirm('Перейти до наступного ряду ?')) {
                                $('.showcasecamera-layout__add').trigger('click');
                                SHOWCASE.row.next().find('.showcase-all-row').trigger('click');
                            }
                             */
                        }

                    }
                }

            },
            error: function(data) {
                alert('Код не розпізнано: ' + text);
            }
        });
    },

    load_camera: function() {
        try {
            this.codeReader.decodeFromVideoDevice(SHOWCASE.selectedDeviceId, 'video', (result, err) => {
                if (result) {
                    if (!this.addBlocked) {
                        this.addBlocked = true;

                        setTimeout( () => {
                            this.addBlocked = false;
                        }, 1000);

                        this.add_qr_sku(result.text);
                    }
                }
                if (err && !(err instanceof ZXing.NotFoundException)) {
                    console.error(err)
                    document.getElementById('someres').textContent = err
                }
            });
        } catch (e) {
        }
        console.log(`Started continous decode from camera with id ${this.selectedDeviceId}`)
    },

    init_slider: function() {
        this.slider = $(".showcase-slider").slick({
            centerMode: true,
            centerPadding: '100px',
            slidesToShow: 1,
            arrows:true,
            infinite: false,
            slidesToScroll: 1,
            dots: false,
            autoplay: false
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            console.log('beforechange')
        }).on('afterChange', function(event, slick, currentSlide, nextSlide){
            console.log('afterchange');
        });
    },

    open_camera: function() {
        this.selected_showcase = $(this);
        $("body .showcasecamera-layout").remove();

        let slider = '';

        slider += '<div class="showcase-slider">';

        for(let i=Math.min(...this.keys); i<=Math.max(...this.keys); i++)
            slider += '<div class="showcase-slide" data-key="' + i + '">' +
                '<div class="showcase-slide-inner">' +
                    '<div class="showcase-slide-number">' + (i + 1) + '</div>' +
                    '<div class="showcase-slide-content empty"></div>' +
                '</div>' +
            '</div>';

        slider += '</div>';

        $("body").prepend(
            '<div class="showcasecamera-layout" id="cameraLayout">' +
            '   <div>' +
            '        <div style="display: none">\n' +
            '            <a class="button showcasecamera-layout__start">Start</a>\n' +
            '            <a class="button showcasecamera-layout__reset">Reset</a>\n' +
            '        </div>' +

            '        <div class="showcasecamera-layout__camera">\n' +
            '            <label for="sourceSelect">Камера:</label>\n' +
            '            <select id="sourceSelect" class="showcasecamera-layout__select"></select>\n' +
            '        </div>\n' +

            '        <div class="showcasecamera-layout__video"><video id="video" width="100%" height="300"></video></div>\n' +

                    '<div class="showcasecamera-layout__helpbuttons"></div>\n' +
                    '<div class="showcasecamera-layout__rownumber">Ряд №' + (this.row.index() + 1) + '</div>\n' +

                    '<div class="showcasecamera-layout__slider">\n' + slider + '</div>\n' +

            '        <div class="showcasecamera-layout__results"></div>\n' +

            '        <div class="camera-layout__buttons">\n' +
            '            <button class="btn showcasecamera-layout__add">Додати</button>\n' +
            '            <button class="btn unsuccess showcasecamera-layout__close">Закінчити</button>\n' +
            '        </div>\n' +

            '   </div>' +
            '</div>');

        this.init_slider();

        U.loadscript("/themes/js/qrcode.min.js", () => {
            this.codeReader = new ZXing.BrowserMultiFormatReader()
            console.log('ZXing code reader initialized')
            this.codeReader.listVideoInputDevices()
                .then((videoInputDevices) => {
                    const sourceSelect = $(".showcasecamera-layout__select");
                    this.selectedDeviceId = videoInputDevices[0].deviceId;

                    if (videoInputDevices.length >= 1) {
                        videoInputDevices.forEach((element) => {
                            let selected = false;
                            if (element.label.match(/back/gi)) {
                                this.selectedDeviceId = element.deviceId;
                                selected = true;
                            }
                            sourceSelect.append('<option value="' + element.deviceId + '" ' + (selected ? 'selected' : '') + '>' + element.label + '</option>');
                        });

                        this.load_camera();
                    }

                })
                .catch((err) => {
                    console.error(err);
                    $("#someres").text = err;
                })
        });

    },

    fill_cell: function(row, cellid, sku, image) {
        let cell = $(".showcase-row[data-id=" + row + "] .showcase-col:eq(" + cellid + ")");

        if (cell)
            cell.addClass('filled').data('sku', sku).html(sku + '<br /><img src="' + image + '" />');
    }
}

export function init_SHOWCASE_events() {
    jQuery(document).ready(function () {

        jQuery("body").on('change', '.showcasecamera-layout__select', function (e) {
            SHOWCASE.selectedDeviceId = $(this).val();
            SHOWCASE.codeReader.reset();
            $(".showcasecamera-layout__start").trigger('click');
        });

        jQuery("body").on('click', '.showcasecamera-layout__gonextrow', function (e) {
            e.preventDefault();
            $('.showcasecamera-layout__add').trigger('click');
            SHOWCASE.row.next().find('.showcase-all-row').trigger('click');
        });

        jQuery("body").on('click', '.showcasecamera-layout__reset', function (e) {
            SHOWCASE.codeReader.reset();
        });

        jQuery("body").on('click', '.showcase-col', function (e) {
            e.preventDefault();

            var btn = $(this);
            let row = btn.parent().parent();
            let open_wizard = false;

            row.parent().find('.showcase-row').not(row).find('.showcase-col.active').removeClass('active');

            if (btn.parent().find('.showcase-col.active').length > 0)
                open_wizard = true;

            btn.addClass('active');

            let keys = [];
            $.each(btn.parent().find('.showcase-col'), function (i, item) {
                item = $(item);

                if (item.hasClass('active'))
                    keys.push(i);
            });

            if (btn.parent().find('.showcase-col.active').length > 1) {

                for (let i = Math.min(...keys); i <= Math.max(...keys); i++) {
                    row.find('.showcase-col:eq(' + i + ')').addClass("active");
                }
            }

            if (open_wizard) {
                SHOWCASE.row = row;
                SHOWCASE.keys = keys;
                SHOWCASE.open_camera();
            }
        });

        jQuery("body").on('click', '.showcase-all-row', function (e) {
            e.preventDefault();

            let btn = $(this);
            let row = btn.parent().parent();

            row.parent().find('.showcase-row').not(row).find('.showcase-col.active').removeClass('active');

            let keys = [];
            $.each(row.find('.showcase-row-list .showcase-col'), function (i, item) {
                item = $(item);
                item.addClass('active');
                keys.push(i);
            });

            SHOWCASE.row = row;
            SHOWCASE.keys = keys;
            SHOWCASE.open_camera();
        });

        jQuery("body").on('click', '.showcasecamera-layout__close', function (e) {
            e.preventDefault();
            try {
                SHOWCASE.codeReader.reset();
            } catch (e) {
                console.log(e);
            }

            $(".showcase-col").removeClass('active');
            $(".showcasecamera-layout").remove();
        });

        jQuery("body").on('click', '.showcasecamera-layout__add', function (e) {
            e.preventDefault();

            // fill
            if ($(".showcase-slider .showcase-slide-content.filled").length > 0) {
                let stats = [];

                $.each($(".showcase-slider .showcase-slide-content.filled"), function (i, item) {
                    item = $(item);
                    SHOWCASE.fill_cell(SHOWCASE.row.data('id'), item.parents('.showcase-slide').data('key'), item.data('sku'), item.find('img').attr('src'));

                    stats.push({
                        store_id: $("[name=store_id]").val(),
                        section_id: $("[name=section_id]").val(),
                        row_id: SHOWCASE.row.index(),
                        position: item.parents('.showcase-slide').data('key'),
                        sku: item.data('sku')
                    });
                });

                if (stats.length)
                    $.ajax({
                        type: "POST",
                        url: "/aj",
                        data: {
                            action: 'slr',
                            to: 'showcasestats',
                            stats: stats
                        },
                        dataType: "json",
                        timeout: 15000, // in milliseconds
                        success: function (data) {

                        },
                        error: function (data) {

                        }
                    });
            }


            $(".showcasecamera-layout__close").trigger('click');

        });

        if ($(".showcase-sections-slider").length > 0)
            $(".showcase-sections-slider").slick({
                centerMode: false,
                centerPadding: '100px',
                slidesToShow: 1,
                arrows: false,
                infinite: true,
                slidesToScroll: 1,
                dots: true,
                autoplay: false
            });

    });
}